module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCA4IDgiPgogICAgPHBhdGggZmlsbD0iIzAwQjkzNiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNi41NDggMS4xMjNhMy44MzYgMy44MzYgMCAxIDEtNS40MjUgNS40MjUgMy44MzYgMy44MzYgMCAwIDEgNS40MjUtNS40MjV6bS0uOTMxLjkxNEwzLjA2OCA0LjU4NSAyLjA1NCAzLjU3MWEuMzc0LjM3NCAwIDEgMC0uNTI4LjUyOWwxLjI3OCAxLjI3OWEuMzc0LjM3NCAwIDAgMCAuNTI5IDBsMi44MTMtMi44MTNhLjM3NC4zNzQgMCAwIDAtLjUzLS41M3oiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/good.svg
// module id = 183
// module chunks = 0